// Presentation hint only, never an authentication or permission signal.
export function isAndroidApp() {
  const fromLauncher = new URLSearchParams(window.location.search).get('android_app') === '1'
    || document.referrer.startsWith('android-app://ir.alefcamp.app');
  try {
    if (fromLauncher) sessionStorage.setItem('alef:android-launch', '1');
    return fromLauncher || sessionStorage.getItem('alef:android-launch') === '1';
  } catch (_) { return fromLauncher; }
}
